import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import { useDonation } from "../Components/DonationContext";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaEye, FaBullseye, FaRegHeart, FaUsers } from "react-icons/fa";
import "./VisionMission.css";

const VisionMission = () => {
  const { openDonation } = useDonation();
  const navigate = useNavigate();

  return (
    <>
      <Header />

      {/* ================= Hero (1521 x 482) ================= */}
      <section className="vm-page">
        <div className="vm-container">
          <div className="vm-hero">
            <div
              className="vm-hero__image"
              style={{ backgroundImage: "url(assets/images/about/vision.png)" }}
            />
            <div className="vm-hero__overlay" />
            <div className="vm-hero__content">
              <motion.h2
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="vm-hero__title"
              >
                Vision & Mission
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="vm-hero__text"
              >
                Vikash envisions empowered, self-sufficient communities where
                every person has access to healthcare, education, and
                sustainable livelihoods, fostering dignity and inclusive
                growth.
              </motion.p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= Vision & Mission cards ================= */}
      <Container className="vm-cardsWrap">
        <Row className="g-4">
          <Col md={6}>
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="vm-card vm-card--top"
            >
              <span className="vm-card__dots" />
              <span className="vm-card__icon">
                <FaEye />
              </span>
              <h3 className="vm-card__title">Vision</h3>
              <span className="vm-card__divider" />
              <p className="vm-card__text">
                Community empowerment for sustainable development and
                protection of rights, fostering inclusive growth, equality,
                environmental balance, and self-reliant communities that
                uphold dignity, justice, and collective well-being for future
                generations.
              </p>
            </motion.div>
          </Col>

          <Col md={6}>
            <motion.div
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="vm-card vm-card--left"
            >
              <span className="vm-card__dots" />
              <span className="vm-card__icon">
                <FaBullseye />
              </span>
              <h3 className="vm-card__title">Mission</h3>
              <span className="vm-card__divider" />
              <p className="vm-card__text">
                A Society Where Basic Needs of Every Individual like Food,
                Shelter, Health, Education, Entertainment etc., are met; where
                Justice, Equality, Liberty and Security are assured; Where
                Co-operative Culture is a Way of Life.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>

      {/* ================= Donate / Join Section ================= */}
      <section className="vm-cta">
        <span className="vm-cta__pattern" aria-hidden="true" />
        <Container>
          <motion.div
            className="vm-cta__inner"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
            }}
          >
            <div className="vm-cta__text">
              <h2 className="vm-cta__title">Support a Child's Future</h2>
              <span className="vm-cta__divider" />
              <p className="vm-cta__lead">
                Your contribution helps provide essential learning materials
                and support to children in need.
              </p>
              <div className="vm-cta__actions">
                <button
                  type="button"
                  className="vm-btn vm-btn--solid"
                  onClick={openDonation}
                >
                  <FaRegHeart /> Donate Now
                </button>
                <button
                  type="button"
                  className="vm-btn vm-btn--outline"
                  onClick={() => navigate("/interns")}
                >
                  <FaUsers /> Join Us
                </button>
              </div>
            </div>

            <div className="vm-cta__imageWrap">
              <img
                src="/assets/images/testimonial/vission.png"
                alt="Child at school"
                className="vm-cta__image"
              />
            </div>
          </motion.div>
        </Container>
      </section>

      <Footer />
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default VisionMission;